import { render, staticRenderFns } from "./prod-list.vue?vue&type=template&id=7336093a&scoped=true"
import script from "./prod-list.vue?vue&type=script&lang=js"
export * from "./prod-list.vue?vue&type=script&lang=js"
import style0 from "./prod-list.vue?vue&type=style&index=0&id=7336093a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7336093a",
  null
  
)

export default component.exports